module.exports = __webpack_public_path__ + "static/breathwork-e0ba78ae07b37b3f25eab093ca5fa671.png";